export const tags = {
    COMPANY: "COMPANY",
    CAMPAIGN_TEMPLATES : 'CAMPAIGN_TEMPLATES',
    SUPER_ADMIN_TOUCHPOINTS : 'SUPER_ADMIN_TOUCHPOINTS',
    JOURNEY: "JOURNEY",
    JOURNEY_CATEGORIES: "JOURNEY_CATEGORIES",
    POSITION: "POSITION",
    EMPLOYEES: "EMPLOYEES",
    USERS:"USERS",
    CANDIDATES: "CANDIDATES",
    HIRING_MANAGER_PORTAL: "HIRING_MANAGER_PORTAL",
    HIRING_MANAGER_DASHBOARD: "HIRING_MANAGER_DASHBOARD",
    CREATE_CALL_HISTORY: "CREATE_CALL_HISTORY",
    TIME_SLOTS: "TIME_SLOTS",
    TOUCH_POINT_INSTANCE:"TOUCH_POINT_INSTANCE",
    MEETING_LOCATIONS: "MEETING_LOCATIONS",
    FILTERS: "FILTERS",
    HIRING_MANAGER_PORTAL_FILTERS: "HIRING_MANAGER_PORTAL_FILTERS",
    DOMO_REPORTS: "DOMO_REPORTS"
}